import { render, staticRenderFns } from "./HeavyPermitSummary.vue?vue&type=template&id=0b9ed22b&scoped=true"
import script from "./HeavyPermitSummary.vue?vue&type=script&lang=js"
export * from "./HeavyPermitSummary.vue?vue&type=script&lang=js"
import style0 from "./HeavyPermitSummary.vue?vue&type=style&index=0&id=0b9ed22b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ed22b",
  null
  
)

export default component.exports